<template>
<div>
    <div v-if="field.type === 'check'" class="custom-control custom-checkbox">
        <input :id="uid" type="checkbox" class="custom-control-input" :checked="!!target[field.key]" @change="set($event.target.checked)">
        <label :for="uid" class="custom-control-label">{{ field.label }}</label>
    </div>

    <template v-else>
        <label :for="uid" class="mb-1">{{ field.label }}</label>

        <input v-if="field.type === 'text' || field.type === 'url'" :id="uid" type="text" class="form-control"
            :value="target[field.key]" :maxlength="field.type === 'url' ? 500 : 300"
            :placeholder="field.type === 'url' ? '/shop, https://…, #showrooms' : ''" @input="set($event.target.value)">

        <textarea v-else-if="field.type === 'textarea' || field.type === 'lines'" :id="uid" class="form-control"
            :rows="field.rows || 4" :value="target[field.key]" maxlength="5000" @input="set($event.target.value)"></textarea>

        <select v-else-if="field.type === 'select'" :id="uid" class="form-control" :value="target[field.key]" @change="set($event.target.value)">
            <option v-for="(label, val) in field.options" :key="val" :value="val">{{ label }}</option>
        </select>

        <div v-else-if="field.type === 'image'" class="d-flex align-items-center" style="gap: 14px;">
            <img v-if="target[field.key]" :src="imageUrl(target[field.key])" alt="" style="width: 150px; height: 90px; object-fit: cover; border-radius: 8px; border: 1px solid #ebedf3;">
            <span v-else class="text-muted small">No picture</span>
            <div>
                <button type="button" class="btn btn-sm btn-primary" @click="$emit('pick')">Choose a picture</button>
                <button v-if="target[field.key]" type="button" class="btn btn-sm btn-light" @click="set('')">Remove</button>
            </div>
        </div>

        <div v-else-if="field.type === 'buttons'">
            <div v-for="(b, i) in list" :key="i" class="d-flex mb-2" style="gap: 6px;">
                <input type="text" class="form-control" style="flex: 0 0 40%;" placeholder="Button text" maxlength="60" :value="b.label" @input="b.label = $event.target.value; emitList()">
                <input type="text" class="form-control" placeholder="/page, https://…, #showrooms" maxlength="500" :value="b.url" @input="b.url = $event.target.value; emitList()">
                <button type="button" class="btn btn-sm btn-light text-danger" @click="list.splice(i, 1); emitList()">✕</button>
            </div>
            <button v-if="list.length < 4" type="button" class="btn btn-sm btn-outline-secondary" @click="list.push({ label: '', url: '' }); emitList()">+ Add a button</button>
        </div>
    </template>

    <small v-if="field.help" class="form-text text-muted">{{ field.help }}</small>
</div>
</template>

<script>
let counter = 0;

export default {
    name: 'BlockField',
    props: {
        field: { type: Object, required: true },
        target: { type: Object, required: true },
        imageUrl: { type: Function, default: v => v },
    },
    data() {
        counter += 1;
        return { uid: 'bf' + counter };
    },
    computed: {
        list() {
            if (!Array.isArray(this.target[this.field.key])) this.$set(this.target, this.field.key, []);
            return this.target[this.field.key];
        },
    },
    methods: {
        set(value) { this.$set(this.target, this.field.key, value); },
        emitList() { this.$set(this.target, this.field.key, this.list.slice()); },
    },
};
</script>
